export default __webpack_public_path__ + "static/media/upload.239edaf9.svg";